import { render, staticRenderFns } from "./ParameterList.vue?vue&type=template&id=0bb78d66"
import script from "./ParameterList.vue?vue&type=script&lang=js"
export * from "./ParameterList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports